function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Container, Row, Col } from 'react-bootstrap';
import Footer from "../components/Footer";
import DefaultNav from "../components/navbars/DefaultNav";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Partners = function Partners() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    displayDrawer = _useState2[0],
    setDisplayDrawer = _useState2[1];
  var showDrawer = function showDrawer() {
    setDisplayDrawer(true);
  };
  var hideDrawer = function hideDrawer() {
    setDisplayDrawer(false);
  };
  useEffect(function () {
    document.title = 'Partenaires';
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(DefaultNav, {
      handleConnectDrawer: displayDrawer,
      hideDrawer: hideDrawer
    }), /*#__PURE__*/_jsxs("div", {
      className: "page-container",
      children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Container, {
        children: /*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsx(Col, {
            lg: 3,
            md: 4,
            sm: 6,
            children: /*#__PURE__*/_jsx("img", {
              src: "drawables/mjeu.jpg",
              style: {
                width: '100%'
              }
            })
          }), /*#__PURE__*/_jsx(Col, {
            lg: 3,
            md: 4,
            sm: 6,
            children: /*#__PURE__*/_jsx("img", {
              src: "drawables/logoapip.png",
              style: {
                width: '100%'
              }
            })
          }), /*#__PURE__*/_jsx(Col, {
            lg: 3,
            md: 4,
            sm: 6,
            children: /*#__PURE__*/_jsx("img", {
              src: "drawables/om.png",
              style: {
                width: '100%'
              }
            })
          })]
        })
      })]
    }), /*#__PURE__*/_jsx(Footer, {})]
  });
};
export default Partners;